// ── Base Model ─────────────────────────────────────────────────────────────────

export interface LocationType {
  id: string;
  sno: number;
  name: string;
  trafficLevel: string;
  commissionPercentage: number;
  description: string;
  cdate: string;
  ctime: string;
  edate: string;
}

// ── Request Payloads ───────────────────────────────────────────────────────────

export interface LocationTypeCreateRequest {
  name: string;
  trafficLevel: string;
  commissionPercentage: number;
  description: string;
}

export interface LocationTypeUpdateRequest {
  name: string;
  trafficLevel: string;
  commissionPercentage: number;
  description: string;
}

// ── API Response Wrappers ──────────────────────────────────────────────────────

export interface ApiBase {
  success: boolean;
  message: string;
  errors: string[];
}

export interface LocationTypeListResponse extends ApiBase {
  result: {
    locationTypes: LocationType[];
  };
}

export interface LocationTypeSingleResponse extends ApiBase {
  result: LocationType;
}

export interface LocationTypeCreateResponse extends ApiBase {
  result: {
    id: string;
  };
}

export interface LocationTypeUpdateResponse extends ApiBase {
  result: {
    id: string;
  };
}

export interface LocationTypeDeleteResponse extends ApiBase {
  result: null;
}

// ── UI Form State ──────────────────────────────────────────────────────────────

export interface LocationTypeFormData {
  name: string;
  trafficLevel: string;
  commissionPercentage: string; // string for text input, parsed before API call
  description: string;
}

export const emptyLocationTypeForm = (): LocationTypeFormData => ({
  name: '',
  trafficLevel: '',
  commissionPercentage: '',
  description: '',
});